import { render, staticRenderFns } from "./airportListDesc.vue?vue&type=template&id=1a9ad2ee&scoped=true"
import script from "./airportListDesc.vue?vue&type=script&lang=js"
export * from "./airportListDesc.vue?vue&type=script&lang=js"
import style0 from "./airportListDesc.vue?vue&type=style&index=0&id=1a9ad2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ad2ee",
  null
  
)

export default component.exports